import {useEffect, useState} from "react";
import Layout from "./layout";
import {makeStyles} from "@mui/styles";
import {Grid} from "@mui/material";

import Slack from "./slides/slack";
import Servers from "./slides/servers";
import CustomMessage from "./slides/custom-message";

function App() {
    const classes = useStyles();
    const SERVER = window.location.origin
        .replace("3000", "8080")
        .replace("cust.commerz.se", "cust.commerz.se:8080")
    ;

    const [currentIndex, setCurrentIndex] = useState(0);
    const [progress, setProgress] = useState(0);
    const [users, setUsers] = useState([]);
    const [services, setServices] = useState([]);
    const [customUrl, setCustomUrl] = useState("");

    const slides = [<Slack data={users}/>, /*<Servers data={services}/>,*/ <CustomMessage data={customUrl}/>];

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${SERVER}/users/commerz`);

            if (response.ok) {
                const data = await response.json();
                let _users = [];
                Object.keys(data).forEach(key => {
                    let user = data[key];
                    user.location = user.tz.includes("London") ? "pt" : "se";
                    user.profileImage = user.image_72;
                    user.statusIcon = user.status_emoji ? user.status_emoji.display_url : null
                    _users.push(user)
                })
                setUsers(_users);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const fetchServices = async () => {
        try {
            const response = await fetch(`${SERVER}/services`)

            if (response.ok) {
                const data = await response.json();
                if (!data.message) {
                    console.log(data.message)
                    return;
                }

                let _services = [];
                Object.keys(data.message).forEach(key => {
                    let service = data.message[key];
                    service.name = "Prodia";
                    service.hdd = "45%";
                    service.ram = "87%";
                    service.uptime = "99.9%";
                    service.webServerStatus = 1;
                    service.latency = "9750";
                    service.hddThreshold = "80%";
                    service.databaseName = "hostname";
                    service.databaseStatus = 1;
                    service.databaseProcesses = 99;
                    _services.push(service)
                })
                setServices(_services);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const fetchCustomMessage = async () => {
        try {
            const response = await fetch(`${SERVER}`)

            if (response.ok) {
                const data = await response.json();
                setCustomUrl(data.custom.url)
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        const slidesInterval = setInterval(() => {
            setProgress((prevProgress) => {
                if (prevProgress >= 20) {
                    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
                    return 0;
                }
                return prevProgress + 1;
            });
        }, 1000);

        return () => clearInterval(slidesInterval)
    }, [])

   /* useEffect(() => {
        if (currentIndex === 0) {
            if (users.length === 0) {
                fetchUsers();
            }
            fetchServices();
        } else if (currentIndex === 2) {
            fetchUsers();
        }

    }, [currentIndex])*/

    useEffect(() => {
        if(currentIndex === 0) {
            if(users.length === 0) {
                fetchUsers();
            }
            fetchCustomMessage();
        } else if(currentIndex === 1) {
            fetchUsers();
        }
    }, [currentIndex]);

    return (
        <Layout currentIndex={currentIndex} progress={progress}>
            <div className={classes.container}>
                {slides[currentIndex]}
                {/*<Slack data={users}/>*/}
            </div>
        </Layout>
    );
}

const useStyles = makeStyles(() => ({
    container: {
        position: "relative",
        zIndex: 1,
        height: "100%"
    },
}));


export default App;
